export enum PublicBoxSortType {
  NameAscending,
  NameDescending,
  PublishedAtAscending,
  PublishedAtDescending,
}
